import React from "react";
import {
  default as BuyStarImg,
  default as heyBroBgStarMobile,
} from "../assets/images/webp/hey-bro-bg-star.webp";
import HeyBro from "../assets/images/webp/Hey-bro.webp";
import HowToBuySlider from "./HowToBuySlider";
import { HOW_TO_BUY_CARDS } from "./common/Helper";
import Tokenomics from "./Tokenomics";

function HowToBuy() {
  return (
    <section
      id="how-to-buy"
      className="bg-soft-blue how_to_buy pb-4 md:pb-10 lg:pb-8 xl:pb-0 mt-[100px] lg:mb-[100px] md:mb-16 sm:mb-10"
    >
      {/* Main container with background color and positioning */}
      <div className="bg-soft-blue 2xl:h-[1440px] xl:h-[1200px] lg:h-[1000px] relative max-w-[1920px] mx-auto overflow-x-clip">
        {/* Background image for larger screens */}
        <img
          className="lg:block hidden object-contain xl:w-[1000px] w-[1000px] animate_bg_star_circle xl:h-[1400px] h-[1000px] absolute top-0 2xl:left-[-45px] lg:left-[-140px] -left-40 custom-1700:w-[1500px] custom-1700:left-[-18%]"
          src={`${BuyStarImg}`}
          alt="BuyStarImg"
        />
        {/* Secondary image for larger screens */}
        <img
          className="2xl:max-w-[726px] max-w-[550px] hidden lg:block absolute xl:top-[21rem] h-[710px] xl:h-[unset] lg:top-56 top-[350px] xl:left-28 lg:left-36 left-10"
          src={`${HeyBro}`}
          alt="HeyBro"
        />
        {/* Heading text for the section */}
        <h2 className="uppercase font-normal leading-113 text-white [text-shadow:4px_4px_0px_#2400FF] whitespace-nowrap 2xl:text-custom-10xl xl:text-custom-8xl lg:text-custom-7xl md:text-custom-6xl text-custom-5xl absolute 2xl:top-[168px] lg:top-[88px] md:top-[100px] top-[71px] right-1/2 translate-x-1/2 2xl:right-[650px] xl:right-[450px] rotate-0 xl:rotate-3">
          HOW TO BUY
        </h2>
        {/* Mapping through HOW_TO_BUY_CARDS to render steps */}
        {HOW_TO_BUY_CARDS.map((obj, index) => {
          return (
            <div
              key={index}
              className={`lg:block hidden 2xl:scale-100 xl:scale-90 lg:scale-[0.65] lg:shadow-lgPurpleShadow shadow-mdPurpleShadow hover:shadow-none transition-all duration-300 ease-in-out border-4 border-dark-purple absolute rounded-3xl bg-pink-bg w-[397px] custom-1800:w-[380px] 2xl:h-[350px] h-[345px] 2xl:pt-6 2xl:pb-6 py-7 2xl:px-6 px-5 hover:translate-x-5 hover:translate-y-5 ${
                index === 0
                  ? "2xl:top-[353px] 2xl:px-6 xl:top-60 top-56 custom-1800:right-[616px] custom-1700:right-[500px] 2xl:right-[309px] xl:right-[300px] right-[220px] rotate-3"
                  : index === 1
                  ? "2xl:top-[627px] xl:top-[530px] lg:top-[400px] top-[620px] custom-1800:right-[316px] custom-1700:right-[140px] 2xl:right-[50px] xl:right-[150px] lg:right-0 right-[50px] -rotate-[7deg]"
                  : index === 2
                  ? "custom-1800:bottom-[235px] 2xl:bottom-[143px] xl:-bottom-4 lg:bottom-12 bottom-44 custom-1800:right-[686px] custom-1700:right-[504px] 2xl:right-[400px] xl:right-[300px] right-[220px] rotate-[7deg]"
                  : "custom-1800:bottom-[-60px] 2xl:bottom-[-118px] xl:bottom-[-280px] lg:bottom-[-140px] bottom-44 custom-1800:right-[345px] custom-1700:right-[140px] 2xl:right-[50px] xl:right-[150px] lg:right-0 right-[50px] -rotate-[7deg]"
              }`}
            >
              {/* Icon image for each step */}
              <img
                className={`absolute 
                ${
                  index === 0
                    ? "-top-[90px] right-9 scale-[0.95] max-h-[186px] max-w-[186px]"
                    : index === 1
                    ? "-top-24 -right-3 scale-[0.95]"
                    : index === 2
                    ? "-top-16 right-12"
                    : "-top-14 scale-[0.95] right-0"
                }
                `}
                src={`${obj.image}`}
                alt="Step-First-Icon"
              />
              <div className="text-dark-purple">
                <h4 className="text-custom-3xl text-white">step {index + 1}</h4>
                <div
                  className={`
                ${
                  index === 0
                    ? "mt-16"
                    : index === 1
                    ? "mt-16 xl:mt-16"
                    : index === 2
                    ? "mt-4"
                    : "mt-16"
                }
                `}
                >
                  <h4
                    className={`capitalize font-luckiest text-white text-custom-3xl leading-7
                ${
                  index === 0
                    ? "max-w-[280px]"
                    : index === 1
                    ? "max-w-[280px]"
                    : index === 2
                    ? "max-w-52"
                    : "max-w-52"
                }
                `}
                  >
                    {obj.heading}
                  </h4>
                  <p
                    className={`text-lg tracking-[-0.054px] text-white font-roboto mt-1  ${
                      index === 0
                        ? "max-w-[321px]"
                        : index === 1
                        ? "max-w-[325px]"
                        : index === 2
                        ? "max-w-[360px]"
                        : ""
                    }`}
                  >
                    {obj.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
        {/* Slider for smaller screens */}
        <div className="md:h-[700px] lg:hidden block">
          <HowToBuySlider />
        </div>
        {/* Image and background effect for smaller screens */}
        <div className="flex lg:hidden justify-center md:pt-48 pt-20 sm:pb-0 lg:pb-10  pb-10 relative">
          <img
            className="sm:max-w-[446px] md:max-w-[446px] max-w-[346px] h-[446px] sm:h-full relative z-10 w-full block lg:hidden"
            src={HeyBro}
            alt="HeyBro"
          />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full">
            <img
              src={heyBroBgStarMobile}
              alt="hey-bro-bg-star-mobile"
              className="w-full h-full animate_bg_star_circle"
            />
          </div>
        </div>
      </div>
      <Tokenomics />
    </section>
  );
}

export default HowToBuy;
